export default __webpack_public_path__ + "static/kingdom-8e20b461ec724218aba01d8cda438900.png";